import { render } from "./ShowIncubator.vue?vue&type=template&id=d504caf6&scoped=true"
import script from "./ShowIncubator.vue?vue&type=script&lang=js"
export * from "./ShowIncubator.vue?vue&type=script&lang=js"

import "./ShowIncubator.vue?vue&type=style&index=0&id=d504caf6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d504caf6"]])

export default __exports__